import { useEffect } from 'react';
import api from '../utils/api';

// Pings the backend that the current customer is live on an order page, so an
// admin gets nudged that someone might want a reply. Fires immediately, on a
// timer, and whenever the tab regains focus. Silently no-ops on error.
export function useOrderPresence(orderId, { enabled = true, intervalMs = 25000 } = {}) {
  useEffect(() => {
    if (!enabled || !orderId) return undefined;

    let active = true;
    const ping = () => {
      if (active) api.post(`/orders/${orderId}/presence`).catch(() => {});
    };

    ping();
    const timer = setInterval(ping, intervalMs);
    const onFocus = () => ping();
    window.addEventListener('focus', onFocus);

    return () => {
      active = false;
      clearInterval(timer);
      window.removeEventListener('focus', onFocus);
    };
  }, [orderId, enabled, intervalMs]);
}

export default useOrderPresence;
